import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import FinanceDialog from "../../../component/FinanceDialog";
import { ArrowBackRounded, InfoRounded } from "@mui/icons-material";
import ReportPreviewTable from "../tables/ReportPreviewTable";
import { useMobilityStoreRepository } from "../../../api/repositories/MobilityStoreRepository";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { formatDate } from "../../../utils/FormatUtils";
import {useRecoilValue, useSetRecoilState} from "recoil";
import { STATE_SUMMARY_UPDATING } from "../../../constants/FinanceRecoil";
import { useAgGridLocale } from "../../../../../config/globalConfig";
import SinglePrintoutsFilter from "../filters/SinglePrintoutsFilter";
import {STATE_SINGLE_PRINTOUT_ACTIVE_FILTERS} from "../constants/MobilityStoreRecoil";

const ReportPreview = () => {
    const {t} = useTranslation('finance', {keyPrefix: 'mobility-store'});
    const {dispatchGlobalData} = useContext(GlobalContext);

    const {getSinglePrintoutsByReportId, getPrintoutsByReportId, publishPrintouts} = useMobilityStoreRepository();

    let {id} = useParams();

    const [data, setData] = useState<any>([]);
    const [totalElements, setTotalElements] = useState<any>(0);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const navigate = useNavigate();
    const agGridLocale = useAgGridLocale();

    const [updating, setUpdating] = useState(false);
    const setSummaryUpdating = useSetRecoilState(STATE_SUMMARY_UPDATING);

    const [publishable, setPublishable] = useState<any>({});
    const [publishableLength, setPublishableLength] = useState(0);
    const filterDefs = useRecoilValue(STATE_SINGLE_PRINTOUT_ACTIVE_FILTERS);


    const onRowSelected = (id: string, isSelected: boolean, node: any) => {
        if (!isSelected) {
            delete publishable[id];
        } else {
            publishable[id] = node;
        }
    }

    useEffect(() => {
        getPrintoutsByReportId(id!)
            .then(response => {
                let result = response.result;
                setData(result.content);
                setTotalElements(result.page.totalElements);
            });
        setSummaryUpdating(true)
    }, []);

    useEffect(() => {
        if (updating) {
            getSinglePrintoutsByReportId(id!, filterDefs)
                .then(response => {
                    let result = response.result;
                    setData(result.content);
                    setTotalElements(result.page.totalElements);
                    setUpdating(false);
                });
        }
    }, [updating])

    useEffect(() => {
        getSinglePrintoutsByReportId(id!, filterDefs)
            .then(response => {
                let result = response.result;
                setData(result.content);
                setTotalElements(result.page.totalElements);
                setUpdating(false);
            });

    }, [filterDefs])

    const sendPrintouts = () => {
        publishPrintouts(Object.keys(publishable))
            .then(() => {
                setUpdating(true);
                setSummaryUpdating(true);
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('preview.publish-confirmation.success-snackbar'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true
                        }
                    }
                });
            })
            .finally(() => {
                setPublishable({});
                setPublishableLength(0);
            })
    }

    useEffect(() => {
        setSummaryUpdating(true);
    }, [agGridLocale]);

    return (
        <Card variant="outlined" sx={{margin: '15px'}}>
            <CardContent>
                <Grid container direction={'column'} rowGap={2}>
                    <Grid item>
                        <Box style={{display: 'flex', alignItems: 'center', gap: '1ch'}}>
                            {/*<ArrowBackRounded onClick={() => {*/}
                            {/*    navigate('/finance/mobility-store');*/}
                            {/*}}/>*/}
                            <Typography variant={'body1'} fontWeight={'bold'}>
                                {t('preview.buttons.back', {reportName: data['0']?.printoutRequest.name})}
                            </Typography>
                        </Box>
                    </Grid>
                    <SinglePrintoutsFilter/>
                    <ReportPreviewTable data={data} selectedDataLength={publishableLength} setSelectedDataLength={setPublishableLength}
                                        setUpdating={setUpdating}
                                        onRowSelected={onRowSelected}
                                        onPublishClick={() => setOpenConfirmationModal(true)} date={formatDate(data['0']?.printoutRequest.created)}/>
                </Grid>
            </CardContent>
            <FinanceDialog title={t('preview.publish-confirmation.title')}
                           content={t('preview.publish-confirmation.content', {selectedRecharges: publishableLength, totalRecharges: totalElements})}
                           open={openConfirmationModal}
                           onClose={() => setOpenConfirmationModal(false)}
                           callback={sendPrintouts}
                           cancelButton={t('preview.publish-confirmation.cancel')}
                           confirmButton={t('preview.publish-confirmation.confirm')}
                           titleIcon={<InfoRounded/>}/>
        </Card>
    );
}

export default ReportPreview;